import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MedicoService } from '../../medico.service';
import { AlertsService } from 'app/shared/alerts.service';
import { Router } from '@angular/router';
import { Paciente } from 'app/core/interfaces/pacient-info.interface';
import { OverlayService } from 'app/shared/overlay.service';
import { APIGestaCardService } from 'app/core/api/gestacard.service';
import { Organizacao } from 'app/core/interfaces/organizacao.interface';
import { Medico } from 'app/core/interfaces/medico.interface';
import { logger } from '../../../../core/utils/console';

@Component({
  selector: 'app-medico-cadastrar-paciente',
  templateUrl: './medico-cadastrar-paciente.component.html',
  styleUrls: ['./medico-cadastrar-paciente.component.scss']
})
export class MedicoCadastrarPacienteComponent implements AfterViewInit {

  form: FormGroup; 
  medico: Medico = Medico.createEmpty(); 
  organizacao: Organizacao;
  emails_medicos: string[] = [];
  emails_enfermeiros: string[] = [];

  bloqueado_por_limite_de_cartoes = false;

  loading = false; 

  @ViewChild('cadastro_paciente') componente_cadastro_paciente; 
  @ViewChild('imageUploader') file_uploader_component;

  constructor(
    private medicoService: MedicoService, 
    private snackService: AlertsService, 
    private router: Router, 
    private overlayService: OverlayService,
    private _apigestacard: APIGestaCardService
  ) { }

  ngAfterViewInit() {

    this.form = this.componente_cadastro_paciente.form; 

    this.BuscarPerfilMedico(); 

  }

  BuscarPerfilMedico() {
    this.medicoService.GetUserData().subscribe((res) => {
      this.medico = res; 

      this.medicoService.GetListaEmailsMedicos().subscribe((res) => {
        this.emails_medicos = res; 
      });

      this.medicoService.GetOrgData().subscribe((org) => {
        this.organizacao = org;
        this.AtualizarFormulario();

        if (this.organizacao.instituicao_publica === 'S') return;

        this.medicoService.TotalCartoesUsadosPeloMedico(this.medico.id).then((result) => {
          
          if (result >= this.medico.maximo_cartoes) this.bloqueado_por_limite_de_cartoes = true;
          
        }).catch((err) => {

          logger.log("MedicoCadastrarPacienteComponent -> BuscarPerfilMedico -> err", err)
          
        });
    
      });
    });
  }

  AtualizarFormulario() {
    this.componente_cadastro_paciente.enabledSearchEmail = true; 
      
    if (this.medico) {
      this.form.patchValue({
        medico: `${this.medico.primeiro_nome} ${this.medico.sobrenome}`, 
        telefone_medico: this.medico.telefone, 
        crm: this.medico.crm,
      }); 
    }

    this.form.removeControl('enfermeiro_app');
    this.form.removeControl('medico_app');

    if (this.organizacao.instituicao_publica === 'S') return;
    
    this.form.removeControl('cns');

    this.loading = false;
  }

  SalvarPaciente() {

    if (this.form.valid) {

      this.loading = true;
      this.overlayService.show(); 

      var aux = this.form.value; 
      aux.medico_app = this.medico.id; 
      const paciente_criado = Paciente.create(aux); 

      this.medicoService.CadastrarPaciente(paciente_criado).then(async (res) => {

        try {

          var imagem_aux = this.file_uploader_component.imagePath;

          // Salvando a imagem 
          if (imagem_aux) {
            var imagem = imagem_aux[0];
            var url_imagem = await this._apigestacard.UploadImage(imagem);

            await this._apigestacard.AtualizarUrlPerfil(res.id, url_imagem);
          }

          this.snackService.SnackMessage('Cadastro feito com sucesso!'); 
          this.router.navigate(['/medico']);
          
        } catch (error) {

          logger.log("MedicoCadastrarPacienteComponent -> SalvarPaciente -> error", error);

        }

      }).catch((err) => {
        var message = '';
        if (typeof err === 'string') message = err;
        if (err.hasOwnProperty('message')) message = err.message;

        if (message == '') message = 'Erro ao cadastrar paciente.';
        
        this.snackService.SnackMessage(message); 

      }).finally(() => {

        this.loading = false;
        this.overlayService.hide(); 

      })

    } else {

      this.snackService.SnackMessage('Formulário invalido'); 

    }

  }

}
